export var getGoogleAnalytics = function () {
    var gaValue = '';
    var googleAnalytics = window.ga;
    if (typeof googleAnalytics !== 'undefined' && googleAnalytics.getAll) {
        var trackers = (googleAnalytics.getAll() || []);
        if (trackers.length > 0) {
            gaValue = trackers[0].get('linkerParam');
        }
    }
    return gaValue;
};
